<template>
  <div class="park-box" :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div
      style="
        display: flex;
        width: 100%;
        height: 38px;
        margin-bottom: 10px;
        border-bottom: 1px solid #acacac;
        align-items: center;
      "
    >
      <img class="titile-logo" src="@/assets/images/titile-logo.png" alt="" />
      <div class="park-box-t">园区（开发区）、滇中新区</div>
    </div>

    <div class="park-box-b">
      <div
        class="park-box-li"
        v-for="(item, index) in list"
        :key="index"
        @click="goDetails(item)"
      >
        <!--<div class="park-box-b-l">
          <img src="../../../assets/images/home/land.png" alt="" />
        </div>-->
        <div class="park-box-b-r">
          <div class="box-left">
            <div class="park-box-b-span1">{{ item.name }}</div>
            <div class="park-box-b-span3">
              <div v-if="item.countyName">{{ item.countyName }}</div>
              <div v-else style="width: 0"></div>
              <div style="margin-left: 10px" v-if="item.developArea">
                <!--                {{ item.parkType }}-->
                {{ twoDecimalPlaces(item.developArea) }}公顷
              </div>
            </div>
          </div>
          <div class="box-right" v-if="item.name != '滇中新区'">
            <div
              class="park-box-b-span2"
              :class="[
                item.parkLevel == '2'
                  ? 'second-stage'
                  : item.parkLevel == '1'
                  ? ''
                  : 'second-stage1',
              ]"
            >
              {{ item.parkLevelName ? item.parkLevelName : "其他" }}
            </div>
          </div>
          <div v-if="item.name == '滇中新区'" class="second-stage3">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getParkIndexList } from "@/api/setting/investment";

export default {
  props: {
    county: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      screenIndexWidth: null,
      list: [],
    };
  },
  watch: {
    county(val) {
      this.getList();
    },
  },

  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
    this.getList();
  },
  methods: {
    getList() {
      getParkIndexList({ county: this.county }).then((res) => {
        if (res.data.success) {
          this.list = res.data.data;
        }
      });
    },
    twoDecimalPlaces(num) {
      if (!!num) {
        return parseFloat(num).toFixed(2);
      }
    },
    // 跳转到详情
    goDetails(item) {
      console.log("跳转");
      this.$router.push({ path: "/parkDetail", query: { id: item.id } });
    },
  },
};
</script>
<style scoped>
.park-box {
  width: calc(100% - 20px);
  height: 100%;
  /* box-shadow: 4px 0 10px #dddddd; */
  margin: 0 10px;
  padding: 0 10px;
}

.park-box-t {
  /* width: 100%; */
  /* height: 35px;
  line-height: 35px; */
  /* padding-bottom: 10px; */
  /* margin-bottom: 10px; */
  /* border-bottom: 1px solid #acacac; */
  font-size: 1.25rem;
  font-weight: 600;
  padding-left: 10px;
}

.park-box-b {
  width: calc(100% - 20px);
  padding: 0 10px;
  height: calc(100% - 46px);
  overflow-y: auto;
}

.park-box-b::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #cfe0f5;
  border-radius: 4px;
}

.park-box-b::-webkit-scrollbar-thumb {
  background-color: rgba(113, 155, 199, 0.7);
  /* background-color: rgba(8, 49, 94, 0.7); */
  border-radius: 4px;
}

.park-box-li {
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex: 0 0 auto;
}

.park-box-b-l {
  width: 120px;
}

.park-box-b-l > img {
  width: 100%;
  height: 100%;
}

.park-box-b-r {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.park-box-b-span3 {
  margin-top: 10px;
  width: 100%;
  display: flex;
  font-size: 0.75rem;
  color: #828181;
}

.park-box-b-span3 > div:first-child {
  padding-right: 10px;
  border-right: 1px solid #a9a8a8;
  width: 45px;
}

.park-box-b-span3 > div:last-child {
  /*padding-left: 10px;*/
}
.park-box-b-span2 {
  height: 100%;
  width: 90px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.95rem;
  font-weight: 600;
  background: rgb(166, 50, 255);
  padding: 10px 13px;
  color: #fff;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}
.second-stage {
  background: rgb(246, 99, 0);
  color: #f7fbff;
}
.second-stage1 {
  background: #03b9cd;
  color: #f7fbff;
}
.second-stage3 {
  height: 22%;
  width: 90px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.95rem;
  font-weight: 600;
  background: rgb(15, 87, 164);
  padding: 10px 13px;
  color: #fff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* text-align: center; */
  cursor: pointer;
}

.park-box-b-span1 {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.85rem;
  color: #000000;
}
.box-left {
  width: 45%;
}
.box-right {
}
.titile-logo {
  width: 40px;
  height: 20px;
}
</style>
